import { render, staticRenderFns } from "./bodyFlexion.vue?vue&type=template&id=208d1cd9&scoped=true&"
import script from "./bodyFlexion.vue?vue&type=script&lang=js&"
export * from "./bodyFlexion.vue?vue&type=script&lang=js&"
import style0 from "./bodyFlexion.vue?vue&type=style&index=0&id=208d1cd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d1cd9",
  null
  
)

export default component.exports